export default "__VITE_ASSET__3c13c84b__"